var router = require('pjax').Router;
var gateways = require('./gateways.js');
var general = require('./general.js');
var pending = require('./pending.js');

router.get('payment/gateways', gateways);
router.get('payment/general', general);
router.get('payment/([a-zA-Z]+)/pending', pending);
